import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./login.css";
import Global from "../../global";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import InPlayer from "../backend/inplayer";
//import { useHistory } from "react-router-dom";
import Loader from "../loader/loader";
//import { UserStore } from "../store/store";
import { setData } from "./logout";
import { setSetting } from "../javascript/function";

const Login = (props) => {
  const lmail = useFormInput("");
  const lpwd = useFormInput("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {}, []);
  const login = async (event) => {
    setLoading(true);
    event.preventDefault();
    await InPlayer.Account.signIn({
      email: lmail.value,
      password: lpwd.value,
      clientId: Global.CLIENTID,
    })
      .then((data) => {
        /*   let obj ={
          NAME:data.data.account.full_name,
          EMAIL:data.data.account.email,
          PHONE:data.data.account.metadata.phoneNumber,
          PHONE_VERIFIED: data.data.account.metadata.phone_verifed,
          WATCHHISTORY:data.data.account.metadata.watchHistory,
          FAVOURITES:data.data.account.metadata.favourites,
          COUNTRY:data.data.account.metadata.country

        }
        
        UserStore.update((s) => {
          s.user = obj;
        }); */
        setData(
          data.data.account.metadata.favourites,
          data.data.account.metadata.watchHistory,
          props.match.params.AppId,
          data.data.account.metadata.phone_verifed
        );
        setSetting(data.data.account.metadata.settings);
        const queryParams = new URLSearchParams(window.location.search);
        const redirect = queryParams.get("redirect");
        const type = queryParams.get("type");
        const after = queryParams.get("after");

        if (Global.LOGIN && Global.SUBSCRIPTION && !Global.OTP) {
          let path = "/" + props.match.params.AppId + "/premium";

          window.location.href = path;
        } else if (Global.LOGIN && !Global.SUBSCRIPTION && !Global.OTP) {
          let path = "/" + props.match.params.AppId + "/home";
          if (type === "video" && after === "login") {
            path = "/" + props.match.params.AppId + "/videopage/" + redirect;
          } else if (type === "video" && after === "premium") {
            path =
              "/" +
              props.match.params.AppId +
              "/premium?type=" +
              type +
              "&redirect=" +
              redirect;
          }

          window.location.href = path;
        } else if (!Global.LOGIN && Global.SUBSCRIPTION && !Global.OTP) {
          let path = "/" + props.match.params.AppId + "/home";
          if (type === "video" && after === "login") {
            path = "/" + props.match.params.AppId + "/videopage/" + redirect;
          } else if (type === "video" && after === "premium") {
            path =
              "/" +
              props.match.params.AppId +
              "/premium?type=" +
              type +
              "&redirect=" +
              redirect;
          }

          window.location.href = path;
        } else {
          let path = "/" + props.match.params.AppId + "/home";
          window.location.href = path;
          //history.push(path);
        }
      })
      .catch((error) => {
        toastr.error("Wrong Credentials", "Error");
        setLoading(false);
      });
  };

  /*  const updateLog = (
    s,
    name,
    email,
    phone,
    phone_verify,
    watchHistory,
    favourites,
    country
  ) => {
    UserStore.update((s) => {
      s.NAME = name;
      s.EMAIL = email;
      s.PHONE = phone;
      s.PHONE_VERIFIED = phone_verify;
      s.WATCHHISTORY = watchHistory;
      s.FAVOURITES = favourites;
      s.COUNTRY = country;
    });
  }; */

  if (loading) {
    return <Loader load={"Default"}></Loader>;
  } else {
    return (
      <section
        className="sign-in-page"
        style={{
          background: "url(/images/home/show-1.jpg) no-repeat scroll 0 0",
        }}
      >
        <div className="container">
          <div className="row justify-content-center align-items-center height-self-center">
            <div className="col-lg-5 col-md-12 align-self-center">
              <div className="sign-user_card ">
                <div className="sign-in-page-data">
                  <div className="sign-in-from w-100 m-auto">
                    <h3 className="mb-3 text-center">Sign in</h3>
                    <form className="mt-4" onSubmit={login}>
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control mb-0"
                          id="email"
                          name="email"
                          placeholder="Enter email"
                          {...lmail}
                          autoComplete="off"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="password"
                          className="form-control mb-0"
                          id="password"
                          name="password"
                          placeholder="Password"
                          {...lpwd}
                          required
                        />
                      </div>
                      <div className="sign-info">
                        {/*   <div className="custom-control custom-checkbox d-inline-block">
                        <input type="checkbox" className="custom-control-input" id="customCheck" />
                        <label className="custom-control-label" htmlFor="customCheck">Remember Me</label>
                     
                     
                     </div>     */}
                        <button
                          type="submit"
                          className="btn btn-hover"
                          style={{ float: "right" }}
                        >
                          Sign in
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div style={{ paddingTop: "40px" }}></div>

                <div className="row text center">
                  <div className="col-sm-12 mt-2">
                    <a href="#!" className="btn fb">
                      {" "}
                      <i
                        className="fa fa-facebook"
                        style={{ marginRight: "5px" }}
                      ></i>
                      Facebook
                    </a>
                  </div>
                  <div className="col-sm-12 mt-2">
                    <a href="#!" className="btn gog">
                      {" "}
                      <i
                        className="fa fa-google"
                        style={{ marginRight: "5px" }}
                      ></i>{" "}
                      Google
                    </a>
                  </div>
                </div>
                <div style={{ paddingTop: "20px" }}></div>
                <div className="mt-3">
                  <div className="d-flex justify-content-center links">
                    Don't have an account?{" "}
                    <Link
                      to={"/" + props.match.params.AppId + "/register"}
                      className="text-primary ml-2"
                    >
                      Sign Up
                    </Link>
                  </div>
                  <div className="d-flex justify-content-center links">
                    <Link to="reset-password.html" className="f-link">
                      Forgot your password?
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return {
    value,
    onChange: handleChange,
  };
};

export default Login;
